window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

const basePath = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

window.axiosInstance = axios.create({
    baseURL: basePath,
});
